/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import Header from "../Header";
import Footer from "../Footer";
import { auth } from "../../lib/firebase";
import { NavLink } from "react-router-dom";
import ar from "../../locale";

export default class Layout extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  toggleSidebar = () => {
    this.$("#sidebar").toggleClass("opened");
  };

  signOut = () => {
    auth.signOut();
  };

  render() {
    return (
      <div className="h-100 d-flex flex-row">
        <div id="sidebar" className="c_sidebar opened">
          <div className="d-flex flex-row p-2 pt-3 pb-3">
            <div className="d-flex justify-content-center align-items-center">
              {this.state.user.photoURL && (
                <img
                  src={this.state.user.photoURL}
                  className="logo-small rounded-circle"
                />
              )}
              {!this.state.user.photoURL && (
                <img
                  src="/assets/images/blankuser.png"
                  className="logo-small rounded-circle"
                />
              )}
            </div>
            <div className="text-white flex1 d-flex justify-content-center align-items-center">
              <h4 className="m-0">{this.state.user.name}</h4>
            </div>
            <button
              id="arrow-menu"
              onClick={this.toggleSidebar}
              className="d-none text-white btn bg-trasparent border-0"
            >
              <i className="fa fa-arrow-right"></i>
            </button>
          </div>
          <div className="menu-items mt-3">
            <nav className="main-nav">
              <ul>
                <li>
                  <NavLink
                    to="/chatroom"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.chatclubs}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/clubs"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.clubs}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/academics"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.academic_talents}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/coach"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.you_r_trainer}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/feminine"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.womens_ball}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/var"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.egy_var}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/awards"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.egy_coach_awards}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/my-hobby"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.my_hobby}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/users"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.user}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/settings"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.settings}</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/slideshow"
                    activeClassName="active"
                    className="link text-white"
                  >
                    <span>{ar.slideshow}</span>
                  </NavLink>
                </li>
                <li>
                  <span
                    onClick={this.signOut}
                    className="cursor-pointer link text-white"
                  >
                    <span>{ar.sign_out}</span>
                  </span>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="content flex1">
          <Header {...this.props} />
          {this.props.children}
          <Footer {...this.props} />
        </div>
      </div>
    );
  }
}
